import { ArrowsUpDownIcon } from '@heroicons/react/20/solid';

interface Props {
  label: string;
  sortKey?: string;
  cyTag: string;
  onSort?: (sortBy: string) => void;
}

export const HeaderRow = (props: Props) => {
  const { label, sortKey, cyTag, onSort } = props;
  return (
    <th
      scope="col"
      className="pb-3 pr-3 text-left text-[13px] font-semibold text-grey-200 border-b border-grey-800"
    >
      {/* [MCV-1539] items-start, not items-center: on flex-col the cross axis is
          horizontal, so items-center centered the label box and visually defeated
          the `text-left` on the <th>. Cells are left-aligned, so headers must be too. */}
      <div className="flex flex-col justify-start items-start">
        <div>{label}</div>
        {sortKey && onSort && (
          <div className="pl-2 flex items-center">
            <button
              type="button"
              data-cy={cyTag}
              onClick={() => onSort(sortKey)}
              aria-label={`Sort by ${label}`}
            >
              <ArrowsUpDownIcon className="size-5 shrink-0" aria-hidden="true" />
            </button>
          </div>
        )}
      </div>
    </th>
  );
};

export const ActionRow = () => {
  return (
    <>
      <th
        scope="col"
        className="pb-3 text-right text-[13px] font-semibold text-grey-200 border-b border-grey-800"
      >
        {/* [MCV-1849] Right-aligned to sit over the right-aligned icons. */}
        <span>Actions</span>
      </th>
    </>
  );
};
